import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DeviceConfigImageField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (newValue === '') {
      setError('Image cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Image Name'
          id='image'
          aria-describedby='image-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={edit}
        />
        {error ? (
          <FormHelperText id='image-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='image-helper-text'>
            Enter the docker image to deploy
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
